import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { useCssProps } from '@uhg-abyss/web/hooks/useCssProps';
import { storage } from '@uhg-abyss/web/tools/storage';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Countdown } from '../../Countdown';
import { RESET_TIME, HAS_SIGNED_OUT } from '../constants';

import { baseStyles } from './IdleModal.styles';

export const IdleModal = ({
  events,
  timeRemaining,
  pingInterval,
  isOpen,
  closeModal,
}) => {
  const [originalExpiredTime, setOriginalExpiredTime] = useState();
  const classes = useCssProps(baseStyles);

  useEffect(() => {
    setOriginalExpiredTime(storage.local.get(RESET_TIME));
  }, [isOpen]);

  const handleSignout = () => {
    storage.local.set(HAS_SIGNED_OUT, true);
    events.onSignout();
  };

  const handleTimeout = () => {
    handleSignout();
  };

  const handleTick = (timeMS) => {
    if (originalExpiredTime !== storage.local.get(RESET_TIME)) {
      closeModal();
    }

    if (storage.local.get(HAS_SIGNED_OUT)) {
      events.onSignout();
    }
    const tickInterval = Math.floor((timeMS % pingInterval) / 1000);

    if (tickInterval === 0) {
      events.onIdleTick(timeMS);
    }
  };

  return (
    <Modal
      title="Session Timeout Warning"
      titleAlign="center"
      width={600}
      isOpen={isOpen}
      canClose={false}
      onClose={closeModal}
    >
      <Modal.Section className={classes.center}>
        <div className={classes.modalText}>
          You will be signed out in a few minutes due to inactivity. All unsaved
          data on this page will be lost.
        </div>
        <div className={classes.modalTextBold}>
          Time remaining:{' '}
          <Countdown
            countdownMS={timeRemaining}
            onTick={handleTick}
            onComplete={handleTimeout}
          />
        </div>
      </Modal.Section>

      <div
        style={{
          display: 'inline-block',
          padding: '20px',
          width: '40%',
          marginLeft: '70px',
        }}
      >
        <Button
          variant="outline"
          onClick={handleSignout}
          style={{ width: '100%' }}
        >
          Sign Out
        </Button>
      </div>
      <div style={{ display: 'inline-block', padding: '20px', width: '40%' }}>
        <Button onClick={closeModal} style={{ width: '100%' }}>
          Continue Working
        </Button>
      </div>
    </Modal>
  );
};

IdleModal.propTypes = {
  timeRemaining: PropTypes.number.isRequired,
  pingInterval: PropTypes.number.isRequired,
  events: PropTypes.shape({
    onIdleTimeout: PropTypes.func,
    setIdleRecovery: PropTypes.func,
    onIdleTick: PropTypes.func,
    onSignout: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
